module.exports = __webpack_public_path__ + "img/wechatQrCode.609d7a77.jpg";